import{jsx as t}from"react/jsx-runtime";import{forwardRef as r}from"react";const e=r((function({size:r,maxLength:e,...n},i){return t("input",{ref:i,size:r,maxLength:e,...n})}));export{e as DatePickerInput};
